/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Vue, Component } from 'vue-property-decorator';
import { Cell, CellGroup } from 'vant';
import { AgreementPo } from '@/po/agreement';
import { jumpToLocal, jumpTo } from '@/shared/utils/jumpTo';
import { AgreementTypeEnum } from '@/enums/agreement-type';
import AgreementApi from '@/api/agreement';
import { isH5App } from '@/constant';
import URLUtils from '@/shared/utils/URLUtils';
import { openContractWithVirtualIframe } from '@/ContractConfig';

const style = require('./index.module.scss');

@Component
export default class ContractList extends Vue {
  // 需要展示的协议
  private contracts: AgreementPo[] = [];

  private async created() {
    try {
      const agreeInfo = await AgreementApi.getAgreedInfo();
      this.contracts = agreeInfo.agreements;
    } catch (e) {
      // just catch
    }
  }

  private render() {
    return (
      <CellGroup>
        {this.contracts.map((item) => (
          <Cell
            id={item.id}
            title={item.agreementName}
            onClick={() => this.showContract(item)}
          >
            <span slot="right-icon" class={style.rightIcon} />
          </Cell>
        ))}
      </CellGroup>
    );
  }

  private showContract(item: AgreementPo) {
    const { id, agreementType, agreementUrl } = item;
    const pathName = agreementType === AgreementTypeEnum.SERVE
      ? 'serve-contract'
      : 'auth-contract';

    // 此操作是为了解决：安卓App环境下，外跳至手机浏览器打开合同链接，下载合同文件后返回至App出现白屏的问题
    const useVirtualIframe = URLUtils.needOpenContractWithVirtualIframe(agreementUrl);
    if (useVirtualIframe) {
      openContractWithVirtualIframe(agreementUrl);
    } else if (isH5App) {
      window.location.href = agreementUrl;
    } else if (agreementUrl) {
      jumpTo(agreementUrl);
    } else {
      jumpToLocal(`redirect/${pathName}?id=${id}`);
    }
  }
}
